import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';




import { aspectsApp } from '@openedx/frontend-app-aspects';

import { staticPagesApp } from '@calculquebec/frontend-static-pages';


import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "evolo",
  baseUrl: 'https://apps.edx.evolo.calculquebec.cloud',
  cmsBaseUrl: 'https://studio.edx.evolo.calculquebec.cloud',
  lmsBaseUrl: 'https://edx.evolo.calculquebec.cloud',
  loginUrl: 'https://edx.evolo.calculquebec.cloud/login',
  logoutUrl: 'https://edx.evolo.calculquebec.cloud/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);


addApp(siteConfig, aspectsApp);

addApp(siteConfig, staticPagesApp);


export default siteConfig;